import { useEffect, useRef } from 'react';
import { isNil } from 'es-toolkit';

export function usePreviousNonNull<T>(value: T, resetKey?: unknown): T {
  const ref = useRef<T>(value);
  const latchedKeyRef = useRef(resetKey);

  if (latchedKeyRef.current !== resetKey) {
    latchedKeyRef.current = resetKey;
    ref.current = value;
  }

  useEffect(() => {
    if (!isNil(value)) {
      ref.current = value;
    }
  });

  return ref.current;
}
